
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16.17","cy":"34.89","r":"14.95","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M23.99 47.53h33.87L40.92 5.31 30.59 31.07M16.26 32.84V60M20.86 38.62l-4.6 4.6-4.6-4.6M40.92 32.84V60"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M45.52 38.62l-4.6 4.6-4.6-4.6M49.77 27.45h5.07a3.94 3.94 0 100-7.87 3.84 3.84 0 00-1.55.32A5.91 5.91 0 0045.5 16M15.72 13.73a4 4 0 010-8A4 4 0 0117.3 6a6 6 0 115.8 7.72z"}})])
          )
        }
      }
    